exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:767px){.popup[data-v-5291b61b]{top:60px;margin:0 10px;background:#efede9;border:0;padding:15px 0 35px}.bt_green a[data-v-5291b61b]{margin-top:3em}.pp_prod_bottom h2.title25[data-v-5291b61b]{margin-top:0!important;padding-top:0!important}}h2.title25[data-v-5291b61b]{margin-bottom:10px}.popup[data-v-5291b61b]{max-width:650px}.bt_green a[data-v-5291b61b]{width:320px}.pp_slide_wrap[data-v-5291b61b]{margin:20px 0}span.open-amount[data-v-5291b61b]{color:#ea4725;display:inline;font-weight:inherit}", ""]);

// exports
